<!-- The Modal -->
<div id="feedback__Modal" class="feedback__modal progress__modal" style="display: flex;">
    <!-- Modal content -->
    <div class="modal-content">
        <div class="popup--close">
            <button (click)="hideModal()"><span class="icon-cross"></span></button>
        </div>
        <div class="feedback__Modal--topsection">
            <img src="assets/images/smiley.svg" alt="">
            <p class="mtb1">Nice Job,</p>
            <h2 class="mtb1">{{user?.firstName}} {{user?.lastName}}!</h2>
            <p class="feedback__Modal--coursename mtb1">Congratulations on completing {{prog?.activation?.title | titlecase}}.</p>
        </div>
    </div>
</div>